// Date/time formatting helpers for event display.
const parse = (s) => (s ? new Date(s) : null);

export const monthShort = (s) =>
  parse(s)?.toLocaleDateString("en-US", { month: "short" }).toUpperCase() || "";

export const dayNum = (s) => parse(s)?.getDate() || "";

export const weekdayLong = (s) =>
  parse(s)?.toLocaleDateString("en-US", { weekday: "long" }) || "";

export const fullDate = (s) =>
  parse(s)?.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  }) || "";

export const timeOnly = (s) =>
  parse(s)?.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }) || "";

export const timeRange = (start, end) => {
  const s = timeOnly(start);
  const e = end ? timeOnly(end) : null;
  return e ? `${s} – ${e}` : s;
};

export const isPast = (endOrStart) => {
  const d = parse(endOrStart);
  return d ? d.getTime() < Date.now() : false;
};
